export const emailValidationError = (email: string) => {
  const emailRegex =
    /^[\w!#$%&'*+/=?^`{|}~-]+(\.[\w!#$%&'*+/=?^`{|}~-]+)*@(\w([\w-]*\w)?\.)+\w[\w-]*\w$/;
  return !emailRegex.test(email);
};
